const directive = {}

directive.onEvent = function (event) {
  if (event.target !== this.el && !this.el.contains(event.target)) {
    directive.cb && directive.cb(event)
  }
}

directive.bind = function (el) {
  console.log('bound')
  // var t = 0
  // t++
  // if (t > 1) {
  directive.onEventBound = directive.onEvent.bind({ el })
  document.addEventListener('click', directive.onEventBound)
    // t++
  // }
}

directive.update = function (el, binding) {
  if (typeof binding.value !== 'function') {
    throw new Error('Argument must be a function')
  }
  directive.cb = binding.value
}

directive.unbind = function () {
  document.removeEventListener('click', directive.onEventBound)
}

export default directive



// WEBPACK FOOTER //
// ./src/vout.js